module.exports = __webpack_public_path__ + "img/logo.a5d6fa57.png";